import { Outlet } from "react-router-dom";

const DashboardLayout = () => {
  return (
    <div className="dashboard-layout">
      {/* sidebar can go here */}
      <Outlet />
    </div>
  );
};

export default DashboardLayout;